import React, { Component } from "react";
import { Fancybox } from "@fancyapps/ui";

class SeriesData extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        Fancybox.bind('[data-fancybox="series-gallery"]', {});
    }

    componentWillUnmount() {
        Fancybox.unbind('[data-fancybox="series-gallery"]');
    }

    convertToLinks(string) {
        var html = string.trim();
        if (html) {
            var url = /https?:\/\/[-|\w(\.|\/)]+/g;
            html = html.replace(
                url,
                '<a style="color:blue; text-decoration:underline;" target="_blank" title="Download" href="$&"><img src="/content/img/icons/pdf_large.png"></a>'
            );
        }

        return html;
    }

    render() {
        return (
            <>
                {this.props.selectedSeries && (
                    <div className="c-series-data">
                        <div className={this.props.isSingleSeries === true ? "" : "inlinedata"}>
                            {this.props.isSingleSeries === false ? (
                                <a
                                    onClick={() => this.props.handleClose()}
                                    className="c-series-data__close"
                                    aria-label="Close modal"
                                >
                                    <i className="icon-clear"></i>
                                </a>
                            ) : (
                                ""
                            )}

                            <div className="row">
                                <div className="col-md-8">
                                    <h3 className="c-series-data__heading">{this.props.selectedSeries.name}</h3>
                                    <p>
                                        {this.props.selectedSeries.tags?.map((tag) => (
                                            <span className="c-series-data__tag" key={tag}>
                                                {tag}
                                            </span>
                                        ))}
                                    </p>

                                    <p
                                        className="c-series-data__paragraph"
                                        dangerouslySetInnerHTML={{
                                            __html: this.convertToLinks(this.props.selectedSeries.excerpt),
                                        }}
                                    />
                                </div>

                                <div className="col pt-5">
                                    <a
                                        href={i18n.CdnHostName + this.props.selectedSeries.imageUrl}
                                        data-fancybox="series-gallery"
                                    >
                                        <img
                                            src={
                                                i18n.CdnHostName +
                                                this.props.selectedSeries.imageUrl +
                                                "?preset=c-series-list&width=170"
                                            }
                                            className="c-parts-modal__image"
                                            alt={this.props.selectedSeries.name}
                                        />
                                    </a>
                                </div>

                                {this.props.selectedSeries.flowchartImageUrl === null ||
                                this.props.selectedSeries.flowchartImageUrl?.length < 4 ? null : (
                                    <div className="col-md-2 pt-5">
                                        <a
                                            href={i18n.CdnHostName + this.props.selectedSeries.flowchartImageUrl}
                                            data-fancybox="series-gallery"
                                        >
                                            <img
                                                src={
                                                    i18n.CdnHostName +
                                                    this.props.selectedSeries.flowchartImageUrl +
                                                    "?preset=c-series-list&width=170"
                                                }
                                                className="c-parts-modal__image"
                                                alt={this.props.selectedSeries.name}
                                            />
                                        </a>
                                        <p className="mb-0 mt-4">
                                            <b>{this.props.selectedSeries.flowchart_Title}</b>
                                        </p>
                                        {this.props.selectedSeries.flowchart_X === null ? null : (
                                            <p className="m-0">
                                                <b>x: </b>
                                                {this.props.selectedSeries.flowchart_X}
                                                <br />
                                                <b>y: </b>
                                                {this.props.selectedSeries.flowchart_Y}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default SeriesData;
